import React from 'react';

import { Box, Button, Dialog, H1, H2, Table, Text } from '@betterment/samba-react';

const TierTypeExampleModal: React.FC<{
  isOpen: boolean;
  closeHandler: () => void;
}> = ({ isOpen, closeHandler }) => {
  return (
    <Dialog open={isOpen} overlay="default" onOpenChange={closeHandler}>
      <Dialog.Content
        css={{
          display: 'flex',
          flexDirection: 'column',
          minWidth: '640px',
          minHeight: '614px',
          p: 'space.400',
          overflow: 'auto',
          pb: 'space.0',
        }}
      >
        <Dialog.Title asChild={true}>
          <H1 variant="title300" css={{ pb: 'space.400' }}>
            Progressive vs. cliff-based tier
          </H1>
        </Dialog.Title>
        <Text css={{ mb: 'space.150' }}>Example: A client has a $250,000 balance using the billing plan below.</Text>

        <Box
          css={{
            border: 'token(borderWidths.thin) solid token(colors.border)',
            borderRadius: 'medium',
          }}
        >
          <Table>
            <Table.Header css={{ paddingTop: 'space.100' }}>
              <Table.Row>
                <Table.ColumnHeaderCell>Balance</Table.ColumnHeaderCell>
                <Table.ColumnHeaderCell>Advisory fee</Table.ColumnHeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell>$0 - $200,000</Table.Cell>
                <Table.Cell>20 bps</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>$200,000 and up</Table.Cell>
                <Table.Cell>10 bps</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Box>
        <Box css={{ my: 'space.200' }}>
          <H2 variant="title100" css={{ mb: 'space.100' }}>
            How progressive tiers work:
          </H2>
          <Text>Client would be charged 20 bps for the first $200,000 and 10 bps for the remaining $50,000.</Text>
        </Box>
        <Box css={{ my: 'space.200' }}>
          <H2 variant="title100" css={{ mb: 'space.100' }}>
            How cliff-based tiers work:
          </H2>
          <Text>Client would be charged 10 bps for the entire $250,000.</Text>
        </Box>
        <Box css={{ my: 'space.200' }}>
          <Button
            data-testid="modal-close-button"
            variant="solidSecondary"
            css={{ width: '90px' }}
            onClick={closeHandler}
          >
            Close
          </Button>
        </Box>
      </Dialog.Content>
    </Dialog>
  );
};

export default TierTypeExampleModal;
